"use strict";
var forms_1 = require('@angular/forms');
var lang_1 = require('../facade/lang');
exports.notEqual = function (val) {
    return function (control) {
        if (lang_1.isPresent(forms_1.Validators.required(control)))
            return null;
        var v = control.value;
        return val !== v ? null : { notEqual: true };
    };
};
//# sourceMappingURL=validator.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-validation/dist/not-equal/validator.js
// module id = 1171
// module chunks = 10